import React, { createContext } from 'react';
import { PAGE_NAME, PAGE_SCOPE } from 'src/constants/GlobalConstants';

export interface IPageContext {
  pageScope: PAGE_SCOPE;
  pageName: PAGE_NAME;
}

const initialPageContext: IPageContext = {
  pageScope: PAGE_SCOPE.AUTHENTICATED,
  pageName: PAGE_NAME.LIST_CASE,
};

export const PageContext = createContext<IPageContext>(initialPageContext);

export const PageProvider: React.FC<IPageContext> = ({
  children,
  pageScope,
  pageName,
}) => {
  return (
    <PageContext.Provider value={{ pageScope, pageName }}>
      {children}
    </PageContext.Provider>
  );
};
